<main id="content" role="main" class="main bg-light">
  <!-- Content -->
  <div class="container py-20 py-sm-7">
    <div class="mx-auto" style="max-width: 45rem;" >
      <!-- Card -->
      <div class="card card-lg mb-5 p-2 pt-5 pb-5">
        <a class="d-flex justify-content-center mb-2" routerLink="/">
          <img class="zi-2" src="../../../assets/images/DumyUser/touch.png" alt="Image Description" style="width: 8rem;">
        </a>
        <div class="card-body">
          <div class="text-center mb-5 mb-md-7" *ngIf="!showOtp">
            <h1 class="h2">
              {{'please_verify_email' | translate}}
            </h1>
            <strong class="p-2">{{"verification_message" | translate}}</strong>
          </div>
          <div class="text-center mb-5 mb-md-7" *ngIf="showOtp">
            <h1 class="h2">
              {{"verify_otp" | translate}}
            </h1>
            <strong class="p-4">{{"enter_otp" | translate}}</strong>
          </div>
          <div class="js-validate needs-validation" novalidate>
            <form [formGroup]="userForm" (ngSubmit)="confirmEmail()" *ngIf="showOtp">
              <div class="mb-3 ">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="form-label" for="signupModalFormResetPasswordEmail" tabindex="0">
                    {{"your_email" | translate}}
                  </label>
                  <a class="form-label-link" type="button" routerLink="/login">
                    <i class="bi-chevron-left small ms-1"></i> 
                    {{"back_to_login" | translate}}
                  </a>
                </div>
                <div class="d-grid row d-flex justify-content-center align-items-center text-center">
                  <p-inputotp formControlName="otp"  [length]="6" />
                </div>
                <div class="error-message text-danger" *ngIf="userForm.get('otp')?.invalid && userForm.get('otp')?.touched">
                  {{"otp_invalid_format" | translate}}
                </div>
              </div>
              <div class="d-grid mb-3" *ngIf="loading">
                <button type="button" class="btn btn-primary btn-lg"> <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></button>
              </div>
              <div class="d-grid mb-3" *ngIf="!loading">
                <button type="submit"  class="btn btn-primary btn-lg" >
                  {{"verify_otp" | translate}}
                </button>
              </div>
            </form>
            <form class="js-validate needs-validation" novalidate *ngIf="!showOtp">
              <div class="mb-3">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="form-label" for="signupModalFormResetPasswordEmail" tabindex="0">
                    {{"your_email" | translate}}
                  </label>

                </div>
                <input type="email" [disabled]="true" value="{{Email}}" class="form-control form-control-lg" name="email" tabindex="1" placeholder="Enter your email address" required>
                <span class="invalid-feedback">
                  {{'valid_email_required' | translate}}
                </span>
              </div>
              <div class="d-grid mb-3" *ngIf="loading">
                <button type="button" class="btn btn-primary btn-lg rounded-4"> <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></button>
              </div>
              <div class="d-grid mb-3" *ngIf="!loading">
                <button type="button" (click)="seondconfirmEmail()" class="btn btn-primary btn-lg shadow rounded-4">
                  {{"send_otp" | translate}}
                </button>
              </div>
            </form>
           
    
          </div>
          <!-- End Form -->
        </div>
      </div>
      <!-- End Card -->

    
    </div>
  
  </div>
  <!-- End Content -->
</main>
<!-- ========== END MAIN CONTENT ========== -->






